import { databaseRef } from 'config'

export const updateForms = (userEmailId: string, userId: string) => {
  return new Promise((resolve, reject) => {
    const databaseOrdered = databaseRef
      .child('forms')
      .orderByChild(`assigned_to/${userEmailId}`)
    const databaseFiltered = databaseOrdered.startAt('')

    databaseFiltered
      .once('value')
      .then(snapshot => {
        const updates = {}
        const res = snapshot.val()

        if (!res) {
          resolve(res)
          return
        }

        for (const formId of Object.keys(res)) {
          updates[`forms/${formId}/assigned_to/${userEmailId}`] = null
          updates[`forms/${formId}/assigned_to/${userId}`] =
            res[formId].assigned_to[userEmailId]
        }

        databaseRef
          .update(updates)
          .then(() => resolve(res))
          .catch(error => reject(error))
      })
      .catch(error => reject(error))
  })
}



// WEBPACK FOOTER //
// ./src/store/user/updateForms.ts